export class MinimumNumberOfTurnaroundsReachedError extends Error {
  constructor() {
    super('The last remaining turnaround cannot be deleted.')
    Object.setPrototypeOf(this, MinimumNumberOfTurnaroundsReachedError.prototype)
  }
}
